import { render, staticRenderFns } from "./RecoveryTabs.vue?vue&type=template&id=902bcd8c&scoped=true"
import script from "./RecoveryTabs.vue?vue&type=script&lang=js"
export * from "./RecoveryTabs.vue?vue&type=script&lang=js"
import style0 from "./RecoveryTabs.vue?vue&type=style&index=0&id=902bcd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902bcd8c",
  null
  
)

export default component.exports